import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { UserManager, WebStorageStateStore } from "oidc-client";
let CallbackViewModel = class CallbackViewModel extends Vue {
    constructor() {
        super();
        const settings = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: process.env.VUE_APP_IDP_BASE_URL,
            client_id: process.env.VUE_APP_IDM_SP_CLIENT_ID,
            redirect_uri: process.env.VUE_APP_IDM_SP_CLIENT_CALLBACK,
            response_type: "id_token token",
            scope: "openid profile",
            post_logout_redirect_uri: process.env.VUE_APP_IDP_BASE_URL + "/oidc/logout",
            filterProtocolClaims: true,
            metadata: {
                issuer: process.env.VUE_APP_IDP_BASE_URL + "/oauth2/token",
                authorization_endpoint: process.env.VUE_APP_IDP_BASE_URL + "/oauth2/authorize",
                userinfo_endpoint: process.env.VUE_APP_IDP_BASE_URL + "/oauth2/userinfo",
                end_session_endpoint: process.env.VUE_APP_IDP_BASE_URL + "/oidc/logout",
                jwks_uri: process.env.VUE_APP_IDP_BASE_URL + "/oauth2/jwks",
            }
        };
        this.userManager = new UserManager(settings);
    }
    async mounted() {
        let user = await this.userManager.signinRedirectCallback();
        console.log('User: ' + JSON.stringify(user));
    }
};
CallbackViewModel = tslib_1.__decorate([
    Component({
        components: {}
    })
], CallbackViewModel);
export default CallbackViewModel;
